export const SESSION_TTL_MS = 30_000;
export const SUCCESS_EVENTS = new Set([
  'FINISH',
  'FINISH_ONLY_WABA',
  'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
]);

export function isCodeExpired(attempt, now = Date.now()) {
  return Boolean(
    attempt?.codeReceivedAt && now - attempt.codeReceivedAt > SESSION_TTL_MS
  );
}

export function recordCode(attempt, code, now = Date.now()) {
  if (!attempt || !code || attempt.submitted) return false;
  if (attempt.code && attempt.code !== code) return false;

  attempt.code = code;
  if (!attempt.codeReceivedAt) attempt.codeReceivedAt = now;
  return true;
}

export function recordSuccessfulSession(attempt, payload) {
  if (!attempt || attempt.submitted || !SUCCESS_EVENTS.has(payload?.event)) return false;
  attempt.sessionData = {
    type: payload.type,
    event: payload.event,
    data: payload.data || {},
  };
  return true;
}

export function isAttemptReady(attempt, now = Date.now()) {
  return Boolean(attempt?.code && attempt?.sessionData && !isCodeExpired(attempt, now));
}
